import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]


export default /*@__PURE__*/_defineComponent({
  __name: 'Icon',
  props: {
    sm: { type: Boolean },
    md: { type: Boolean },
    lg: { type: Boolean },
    iconName: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: require(`@icons/${_ctx.iconName}.svg`),
    class: _normalizeClass({ sm: _ctx.sm, md: _ctx.md, lg: _ctx.lg }),
    role: "presentation"
  }, null, 10, _hoisted_1))
}
}

})